export default {
    title: 'Perfil',
    subtitle: 'Gestiona tu información personal y preferencias',
    tabs: {
        preferences: 'Preferencias',
        account: 'Cuenta',
        password: 'Contraseña',
        picture: 'Foto de Perfil',
        companies: 'Empresas',
        team: 'Equipo',
        integrations: 'Integraciones',
    },
    preferences: {
        language: {
            title: 'Idioma',
            description: 'Selecciona tu idioma preferido para la interfaz',
        },
        theme: {
            title: 'Tema',
            description: 'Elige entre tema claro y oscuro',
        },
    },
    account: {
        title: 'Información de la Cuenta',
        description: 'Actualiza tu información personal',
        legalSection: {
            title: 'Legal',
            description: 'Consulta nuestros Términos y condiciones y la Política de privacidad.',
        },
        firstName: 'Nombre',
        firstNamePlaceholder: 'Ingresa tu nombre',
        lastName: 'Apellido',
        lastNamePlaceholder: 'Ingresa tu apellido',
        email: 'Correo Electrónico',
        emailPlaceholder: 'Ingresa tu dirección de correo electrónico',
        phone: 'Teléfono',
        phonePlaceholder: 'Ingresa tu número de teléfono',
        jobTitle: 'Cargo',
        jobTitlePlaceholder: 'Ingresa tu cargo',
        department: 'Departamento',
        departmentPlaceholder: 'Ingresa tu departamento',
    },
    password: {
        title: 'Cambiar Contraseña',
        description: 'Actualiza la contraseña de tu cuenta',
        currentPassword: 'Contraseña Actual',
        currentPasswordPlaceholder: 'Ingresa tu contraseña actual',
        newPassword: 'Nueva Contraseña',
        newPasswordPlaceholder: 'Ingresa tu nueva contraseña',
        confirmPassword: 'Confirmar Contraseña',
        confirmPasswordPlaceholder: 'Confirma tu nueva contraseña',
        mismatch: 'Las contraseñas no coinciden',
        changePassword: 'Cambiar Contraseña',
    },
    picture: {
        title: 'Foto de Perfil',
        description: 'Sube y gestiona tu foto de perfil',
        global: 'Global (Todas las Empresas)',
        scope: 'Alcance',
        scopeDescription: 'Elige si esta imagen debe ser visible globalmente o solo para una empresa específica',
        selectFile: 'Seleccionar Archivo',
        upload: 'Subir',
        invalidFileType: 'Tipo de archivo no válido. Por favor selecciona una imagen PNG, JPG, JPEG o WEBP.',
        fileTooLarge: 'El tamaño del archivo excede el límite de 5MB.',
    },
    companies: {
        title: 'Empresas',
        description: 'Ver todas las empresas de las que formas parte',
        noCompanies: 'No formas parte de ninguna empresa',
        primary: 'Principal',
        noType: 'Sin Tipo',
        types: {
            sender: 'Remitente',
            receiver: 'Destinatario',
            freight_forwarder: 'Agente de Carga',
            port_authority: 'Autoridad Portuaria',
            carrier: 'Transportista',
            customs_broker: 'Agente Aduanero',
            insurance_provider: 'Proveedor de Seguros',
        },
        role: {
            super_admin: 'Super Administrador',
            company_admin: 'Administrador de Empresa',
            operator: 'Operador',
            viewer: 'Visualizador',
        },
        editDetails: 'Detalles de la empresa',
    },
    companyEdit: {
        nav: {
            companyInfo: 'Datos de la empresa',
            hsCodes: 'Códigos HS',
            routes: 'Rutas',
            carriers: 'Navieros',
            ariaLabel: 'Secciones del perfil de empresa',
        },
        title: 'Perfil de la empresa',
        back: 'Volver a empresas',
        save: 'Guardar cambios',
        saved: 'Perfil de empresa guardado',
        saveError: 'No se pudo guardar el perfil de la empresa',
        loadError: 'No se pudieron cargar los datos de la empresa',
        notMember: 'No perteneces a esta empresa',
        readOnlyHint:
            'Solo los administradores de la empresa pueden editar estos datos. Contacta a un administrador si necesitas cambios.',
        retry: 'Reintentar',
        operationalProfile: {
            title: 'Perfil operativo',
            description:
                'Indica tus códigos HS principales, rutas y navieros preferidos. Completa la lista del Control Hub y enriquece el contexto de Ask Eve.',
            hsHeading: 'Productos (códigos HS)',
            hsLabel: 'Código HS',
            hsSearchLabel: 'Buscar códigos HS',
            hsSearchPlaceholder: 'Palabras clave o dígitos (ej. avocado, 0804)',
            hsPlaceholder: 'p. ej. 080440',
            hsInvalid: 'Introduce un código HS válido (dígitos y puntos, mín. 4 caracteres).',
            add: 'Añadir',
            hsEmpty: 'No hay códigos HS añadidos.',
            hsAlreadyDeclared: 'Este código HS ya está en la lista.',
            hsAddCodesButton: 'Añadir códigos HS',
            hsTableFilterHint:
                'Filtra la tabla de abajo — para añadir códigos nuevos usa el botón de arriba.',
            removeHs: 'Quitar {{code}}',
            routesHeading: 'Rutas principales',
            addRoute: 'Añadir ruta',
            routesEmpty: 'No hay rutas añadidas.',
            routesIncomplete: 'Completa cada ruta (puerto origen y destino) o elimina las filas incompletas.',
            legacyRouteHint: 'Guardada como países: {{origin}} → {{dest}}. Selecciona puertos abajo para actualizar.',
            origin: 'País de origen',
            destination: 'País de destino',
            originPort: 'Puerto de origen',
            destinationPort: 'Puerto de destino',
            portSearchPlaceholder: 'Buscar puerto o UN/LOCODE',
            routeNote: 'Nota (opcional)',
            removeRoute: 'Eliminar ruta',
            carriersHeading: 'Navieros más usados',
            carrierSelectLabel: 'Añadir naviero',
            carrierSearchLabel: 'Buscar navieros',
            carrierSearchPlaceholder: 'Nombre o SCAC',
            carrierPlaceholder: 'Selecciona un naviero',
            addCarrier: 'Añadir naviero',
            carriersEmpty: 'No hay navieros añadidos.',
            carriersAddButton: 'Añadir navieros',
            carriersTableFilterHint:
                'Filtra la tabla de abajo — para añadir navieros usa el botón de arriba.',
            carrierAlreadyDeclared: 'Este naviero ya está en la lista.',
            carrierModalTitle: 'Añadir navieros',
            carrierModalDescription:
                'Busca y selecciona uno o más navieros oceánicos. Se añadirán al confirmar.',
            carrierModalStagingEmpty: 'Ningún naviero seleccionado — busca arriba para añadir.',
            carrierModalCancel: 'Cancelar',
            carrierModalConfirm: 'Añadir a la lista',
            removeCarrier: 'Quitar {{scac}}',
            hsTableSearchPlaceholder: 'Buscar en la lista…',
            hsTableTitle: 'Códigos HS declarados',
            hsCodeColumn: 'Código',
            hsDescriptionColumn: 'Descripción',
            tableActions: 'Acciones',
            routesTableSearchPlaceholder: 'Buscar rutas…',
            routesTableTitle: 'Rutas',
            routesTableHint: 'Expande una fila para editar los arreglos documentales y subir PDF.',
            carriersTableSearchPlaceholder: 'Buscar navieros…',
            carriersTableTitle: 'Navieros',
            hsModalTitle: 'Añadir códigos HS',
            hsModalDescription:
                'Busca y selecciona uno o más códigos. Se añadirán al confirmar.',
            hsModalStagingEmpty: 'Ningún código seleccionado — busca arriba para añadir.',
            hsModalCancel: 'Cancelar',
            hsModalConfirm: 'Añadir a la lista',
            carrierColumnScac: 'SCAC',
            carrierColumnName: 'Nombre',
            carrierColumnCountry: 'País',
            saveOperational: 'Guardar perfil operativo',
            saved: 'Perfil operativo guardado',
            saveError: 'No se pudo guardar el perfil operativo',
            loadError: 'No se pudo cargar el perfil operativo',
        },
    },
    integrations: {
        title: 'Integraciones de Correo',
        description: 'Conecta tus cuentas personales de Gmail o Outlook a Eve Mind',
        connectedAccounts: 'Cuentas Conectadas',
        connectNew: 'Conectar Nueva Cuenta',
        connectGmail: 'Conectar Gmail',
        connectOutlook: 'Conectar Outlook',
        confirmDisconnect: '¿Estás seguro de que deseas desconectar esta cuenta de correo?',
        providers: {
            gmail: 'Gmail',
            outlook: 'Outlook',
        },
        status: {
            active: 'Activo',
            inactive: 'Inactivo',
            error: 'Error',
            authentication_required: 'Autenticación Requerida',
        },
    },
};

